/**
 * Utilities for building URLs to external Buffer products (Analyze, Start Page, etc.)
 */

import { getUrl } from '@buffer-mono/shared-utils/bibe'

/**
 * Build a URL to the Analyze product homepage
 * Handles BIBE environments correctly (e.g., 42.prod-bibes.analyze.buffer.com)
 * @returns URL to Analyze home (e.g., https://analyze.buffer.com/)
 */
export const buildAnalyzeHomeUrl = (): string => {
  return getUrl('https://analyze.buffer.com/')
}

/**
 * Build a URL to a specific channel's analytics page in Analyze
 * Handles BIBE environments correctly
 * @param channelId - The channel ID
 * @param service - The channel service type (e.g., 'instagram', 'facebook', 'twitter')
 * @returns URL to channel analytics (e.g., https://analyze.buffer.com/instagram/overview/123)
 */
export const buildAnalyzeChannelUrl = (
  channelId: string,
  service: string,
): string => {
  if (!channelId || !service) {
    throw new Error('channelId and service are required')
  }
  return getUrl(
    `https://analyze.buffer.com/${encodeURIComponent(
      service,
    )}/overview/${encodeURIComponent(channelId)}`,
  )
}

/**
 * Build a URL to the Start Page editor for a specific channel
 * Handles BIBE environments correctly
 * @param channelId - The channel ID
 * @returns URL to Start Page editor (e.g., https://start-page.buffer.com/123)
 */
export const buildStartPageEditorUrl = (channelId: string): string => {
  if (!channelId) {
    throw new Error('channelId is required')
  }
  return getUrl(
    `https://start-page.buffer.com/${encodeURIComponent(channelId)}`,
  )
}

/**
 * Build a URL to the Start Page app home
 * Handles BIBE environments correctly
 * @returns URL to Start Page home (e.g., https://start-page.buffer.com/)
 */
export const buildStartPageHomeUrl = (): string => {
  return getUrl('https://start-page.buffer.com/')
}
